import fromPairs from 'lodash/fromPairs'

export const definePropType = val => ({ [wrapperKey]: val })

const isObject = function (obj) {
  return obj !== null && typeof obj === 'object'
}
// eslint-disable-next-line no-undef
const wrapperKey = Symbol()
// eslint-disable-next-line no-undef
export const propKey = Symbol()

export function buildProp(option, key) {
  // filter native prop type and nested prop, e.g `null`, `undefined` (from `buildProps`)
  if (!isObject(option) || !!option[propKey]) return option

  const { values, required, default: defaultValue, type, validator } = option

  const _validator =
    values || validator
      ? val => {
          let valid = false
          let allowedValues = []

          if (values) {
            allowedValues = [...values, defaultValue]

            if (!valid) {
              valid = allowedValues.includes(val)
            }
          }
          if (validator) {
            if (!valid) {
              valid = validator(val)
            }
          }

          if (!valid && allowedValues.length > 0) {
            // eslint-disable-next-line no-undef
            const allowValuesText = [...new Set(allowedValues)].map(value => JSON.stringify(value)).join(', ')
            console.warn(
              `Invalid prop: validation failed${
                key ? ` for prop "${key}"` : ''
              }. Expected one of [${allowValuesText}], got value ${JSON.stringify(val)}.`
            )
          }
          return valid
        }
      : undefined

  return {
    type: typeof type === 'object' && Object.getOwnPropertySymbols(type).includes(wrapperKey) ? type[wrapperKey] : type,
    required: !!required,
    default: defaultValue,
    validator: _validator,
    [propKey]: true,
  }
}

export const buildProps = props =>
  fromPairs(Object.entries(props).map(([key, option]) => [key, buildProp(option, key)]))

export const affixProps = buildProps({
  zIndex: {
    type: definePropType([Number, String]),
    default: 100,
  },
  target: {
    type: String,
    default: '',
  },
  offset: {
    type: Number,
    default: 0,
  },
  position: {
    type: String,
    values: ['top', 'bottom'],
    default: 'top',
  },
})

export const affixEmits = {
  scroll: ({ scrollTop, fixed }) => typeof scrollTop === 'number' && typeof fixed === 'boolean',
  change: fixed => typeof fixed === 'boolean',
}
